import React from 'react';
import './PaymentResult.css';

const PaymentPending = () => {
  return (
    <div className="payment-result-container pending">
      <div className="payment-result-content">
        <div className="payment-icon pending-icon">⏱</div>
        <h1 className="payment-title">PAGO PENDIENTE</h1>
        <p className="payment-message">
          Tu pago está siendo procesado.
        </p>
        <div className="payment-details">
          <p>Te notificaremos por email cuando se confirme el pago.</p>
          <p>Esto puede tomar unos minutos o días dependiendo del método de pago elegido.</p>
        </div>
        <div className="payment-actions">
          <a href="/" className="btn-volver-inicio">VOLVER AL INICIO</a>
        </div>
      </div>
    </div>
  );
};

export default PaymentPending;
